/** Насколько опаздывает публикация (PUB-UC-1): меньше onTimeMinutes (ui.publishing) — «вовремя». */
export type Overdue = { onTime: true } | { onTime: false; value: number; unit: 'minute' | 'hour' | 'day' };

export function overdueOf(plannedAt: string, now: number, onTimeMinutes: number): Overdue {
  const minutes = Math.floor((now - new Date(plannedAt).getTime()) / 60_000);
  if (minutes < onTimeMinutes) return { onTime: true };
  if (minutes < 60) return { onTime: false, value: minutes, unit: 'minute' };
  if (minutes < 60 * 48) return { onTime: false, value: Math.floor(minutes / 60), unit: 'hour' };
  return { onTime: false, value: Math.floor(minutes / 1440), unit: 'day' };
}
